var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "formatter" }, [
    _c(
      "div",
      { staticClass: "d-flex gap-5 groups" },
      [
        _c("TimezonePickerInput", {
          attrs: { title: "First Date Timezone" },
          model: {
            value: _vm.clone.isBetween.fromTimezone,
            callback: function ($$v) {
              _vm.$set(_vm.clone.isBetween, "fromTimezone", $$v)
            },
            expression: "clone.isBetween.fromTimezone",
          },
        }),
        _vm._v(" "),
        _c("TimezonePickerInput", {
          attrs: { title: "Others Date Timezone" },
          model: {
            value: _vm.clone.isBetween.toTimezone,
            callback: function ($$v) {
              _vm.$set(_vm.clone.isBetween, "toTimezone", $$v)
            },
            expression: "clone.isBetween.toTimezone",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "d-flex gap-5 groups" },
      [
        _c("FormatPickerInput", {
          attrs: { title: "First Date Format" },
          model: {
            value: _vm.clone.isBetween.fromFormat,
            callback: function ($$v) {
              _vm.$set(_vm.clone.isBetween, "fromFormat", $$v)
            },
            expression: "clone.isBetween.fromFormat",
          },
        }),
        _vm._v(" "),
        _c("FormatPickerInput", {
          attrs: { title: "Others Date Format" },
          model: {
            value: _vm.clone.isBetween.toFormat,
            callback: function ($$v) {
              _vm.$set(_vm.clone.isBetween, "toFormat", $$v)
            },
            expression: "clone.isBetween.toFormat",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "d-flex gap-5 groups" },
      [
        _c("LocalePickerInput", {
          attrs: { title: "First Date Locale" },
          model: {
            value: _vm.clone.isBetween.fromLocale,
            callback: function ($$v) {
              _vm.$set(_vm.clone.isBetween, "fromLocale", $$v)
            },
            expression: "clone.isBetween.fromLocale",
          },
        }),
        _vm._v(" "),
        _c("LocalePickerInput", {
          attrs: { title: "Others Date Locale" },
          model: {
            value: _vm.clone.isBetween.toLocale,
            callback: function ($$v) {
              _vm.$set(_vm.clone.isBetween, "toLocale", $$v)
            },
            expression: "clone.isBetween.toLocale",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "d-flex gap-5" }, [
      _c(
        "div",
        { staticClass: "editor-row customize-editor-minimize" },
        [
          _c("div", { staticClass: "editor-row-title" }, [
            _vm._v("Include Boundaries"),
          ]),
          _vm._v(" "),
          _c("a-switch", {
            model: {
              value: _vm.clone.isBetween.inclusive,
              callback: function ($$v) {
                _vm.$set(_vm.clone.isBetween, "inclusive", $$v)
              },
              expression: "clone.isBetween.inclusive",
            },
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }